import React from "react";
import { Tooltip } from "react-tooltip";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/bookingsSagas";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

export const BookingDate = () => {
  const dispatch = useDispatch();

  const booking_date = useSelector((state) => state.bookings.selectedFilters.booking_date);

  const tooltipId = "booking-date-tooltip";

  return (
    <>
      <p
        data-tooltip-id={tooltipId}
        data-tooltip-content={booking_date ? "Booking date" : "Log Date"}
      >
        Booking Date
      </p>

      <ToggleableButton
        isActive={booking_date}
        isRadio
        title="booking_date"
        onClick={(data) => dispatch(actionCreators.updateBookingDate(data))}
      />

      <Tooltip id={tooltipId} float />
    </>
  );
};
